var formAction = "https://landingreceiver.youandemili.com/api/v1/landing/process/json";
var gdprFormDescriptor = "https://landingreceiver.youandemili.com/api/v1/integrations/cnhgpdr/config";
var provinceUrl = "https://landingreceiver.youandemili.com/api/v1/localization/provinces";
var comuniUrl = "https://landingreceiver.youandemili.com/api/v1/localization/provinces/municipalities";
var storeUrl = "https://landingreceiver.youandemili.com/api/v1/integrations/store";

var configFile = globalVariables.basePath + "/content/data/contents.json?v=" + new Date().getTime();
var genericError = "";
var userExistError = "";
var successTitle = "";
var successMessage = "";
var errorMessage = "";
var errorMessageEmail = "";
var errorMessagePhone = "";

$(document).ready(function () {

  $("#phonenumber").keypress(function (e) {
    if (String.fromCharCode(e.which).match(/[^+()0-9 \-]/)) {
      e.preventDefault();
    }
  });

  $(".ae-btn-submit").attr("disabled", "disabled");

  getData();

  configLandigReceiver();


  $('.scroll-link').click(function (e) {
    e.preventDefault();
    $(window).stop(true).scrollTo(this.hash, {
      duration: 1500,
      offset: 0,
      easing: 'easeOutCirc'
    });
  });

});

$(document).on('lazyloaded', function (e) {
  var $target = $(e.target);
  var $parent = $target.parent();
  if ($parent.hasClass("ae-img-spinner")) {
    $parent.addClass("ae-loaded");
  }
});

$(window).on("load", function () {
  $(".ae-img-spinner:not(.ae-loaded) .lazyloaded").each(function () {
    $(this).parent().addClass("ae-loaded");
    $(this).addClass("ae-loaded");
  });
});

$(window).on("resize", function () {
  switchLazyBg(".ae-header");
  // switchLazyBg(".ae-section-promo");
  // switchLazyBg(".ae-info-image");
  // switchLazyBg(".ae-section-info-bottom");
  
});

/***** FUNCTIONS  *****/


function switchLazyBg(item) {
  var $h = $(item);
  var bg = $h.attr('data-bg');
  if ($h.hasClass("lazyloaded")) {
    if ($(window).width() <= 576) {
      bg = $h.attr('data-bg-mobile');
    }

    var current = $h.css("background-image");
    if (current.indexOf(bg) === -1) {

      $h.css({
        "background-image": 'url(' + bg + ')'
      });

    }
  }
}

function getData() {
  var promo = $("#promo").val();


  var found = false;
  $.getJSON(configFile, function (data) {
    $.each(data, function (k, level1) {
      $.each(level1, function (k1, val) {
        if (promo == val["promo"].toUpperCase()) {
          found = true;
          var promoData = val["data"];
          $("#lid").val(promoData["lid"]);
          $("#landingName").val(promoData["landingName"]);
          $("#language").val(promoData["language"]);
          $("#model").val(promoData["model"]);
          $("#productbrand").val(promoData["productbrand"]);
          $("#codepromotion").val(promoData["codepromotion"]);
          $("#contactlanguage").val(promoData["contactlanguage"]);
          genericError = promoData["genericError"];
          userExistError = promoData["userExistError"];
          successTitle = promoData["successTitle"];
          successMessage = promoData["successMessage"];
          errorMessage = promoData["errorMessage"];
          errorMessageEmail = promoData["errorMessageEmail"];
          errorMessagePhone = promoData["errorMessagePhone"];


          if ($("body").hasClass("it")) {
            GetProvince();
            GetPurchaseIntention();

            $("#city").on("change", function () {
              $("#cityname").val($("#city option:selected").text());
            });

            $("#province").on("change", function () {
              $("#provincename").val($("#province option:selected").text());
              GetComuni($("#province").val());
            });

            $("#purchaseintention").on("change", function () {
              setPurchaseIntentionCRM();
              setPurchaseIntentionText();
            });
          }

          if ($("body").hasClass("es")) {
            GetProvince();

            $("#city").on("change", function () {
              $("#cityname").val($("#city option:selected").text());
            });

            $("#province").on("change", function () {
              $("#provincename").val($("#province option:selected").text());
              GetComuni($("#province").val());
            });
          }
        }
      });
    });

    if (promo != "FR-BE" && promo != "NL") {

      if (promo == "ES") {
        $(".ae-btn-submit").removeAttr("disabled");
      } else {
        /** GDPR **/
        GetFormDescriptor();
      }

      

      if (promo == "ES") {
        $.validator.addMethod('customphone', function (value, element) {
          return this.optional(element) || /^([+]\d{1,2})?\d{9}$/.test(value);
        }, "Por favor ingrese un número de teléfono válido.");

        setFormValidationES();
      } else {
        setFormValidation();
      }

    } else {
      console.log("external form");
    }

    if (!found) {
      console.log("not found");
      //location.href = "/"
    }
  });
}

function setPurchaseIntentionCRM() {
  $("#purchaseintentionCRM").val($("#purchaseintentionCRM").attr("ae-data-msg") + " " + $("#purchaseintention option:selected").text());
}

function setPurchaseIntentionText() {
  $("#purchaseintentionText").val($("#purchaseintention option:selected").text());
}

function setFormValidation() {
  //form validate 
  $("#landing-form").validate({
    errorElement: "span",
    preferredContact: {
      required: true
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      phonenumber: errorMessage,
      postalcode: errorMessage,
      city: errorMessage,
      businessname: errorMessage,
      province: errorMessage,
      purchaseintention: errorMessage,
      email: {
        required: errorMessage,
        email: errorMessageEmail
      },
      gdpr_0: errorMessage,
      gdpr_1: errorMessage,
      gdpr_2: errorMessage,
    }
  });
}

function setFormValidationES() {
  //form validate 
  $("#landing-form").validate({
    errorElement: "span",
    preferredContact: {
      required: true
    },
    rules: {
      phonenumber: 'customphone'
    },
    messages: {
      firstname: errorMessage,
      lastname: errorMessage,
      phonenumber: {
        required:errorMessage,
        customphone: "Por favor ingrese un número de teléfono válido."
      }, 
      postalcode: errorMessage,
      city: errorMessage,
      businessname: errorMessage,
      province: errorMessage,
      purchaseintention: errorMessage,
      email: {
        required: errorMessage,
        email: errorMessageEmail
      },
      gdpr_0: errorMessage,
      gdpr_1: errorMessage,
      gdpr_2: errorMessage,
    }
  });
}


function configLandigReceiver() {
  //campaign tracking
  var gtmref = getUrlParameter("utm_source");
  var gtmcampaign = getUrlParameter("utm_campaign");
  var gtmmedium = getUrlParameter("utm_medium");
  var gtmcontent = getUrlParameter("utm_content");

  if (gtmref != undefined) {
    $("#gtmref").val(gtmref);
  }
  if (gtmcampaign != undefined) {
    $("#gtmcampaign").val(gtmcampaign);
  }

  if (gtmmedium != undefined) {
    $("#gtmmedium").val(gtmmedium);
  }

  if (gtmcontent != undefined) {
    $("#gtmcontent").val(gtmcontent);
  }

  //final form post
  $("#landing-form").submit(function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = $("#landing-form");

    if (form.valid()) {
      $(".ae-btn-submit").attr("disabled", "disabled");
      $("#waiting-form").removeClass("d-none");

      postData(form);
    }
    return false;
  });
}

function postData(form) {
  var formData = form.serializeArray();

  var jsonData = {
    "url": window.location.href,
    "name": $("#landingName").val(),
    "id": $("#lid").val(),
    "data": objectifyForm(formData)
  };

  //console.log(jsonData);

  //post
  $.ajax({
    async: true,
    type: "POST",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: formAction,
    dataType: "json",
    contentType: "application/json",
    data: JSON.stringify(jsonData),
    success: function (resp) {
      //console.log(resp);
      var obj = JSON.parse(JSON.stringify(resp));
      if (obj.status === 1) {
        try {

          //Tracciamento del form inviato
          /**** GTM Navigation Event ****/
          if (typeof dataLayer !== "undefined") {

            dataLayer.push({
              "event": "Pageview",
              "pagePath": location.pathname.replace("index.html", "") + "/form-send/",
              "pageTitle": "Forn send | " + $(document).find("title").text() 
            });
          }

          showSuccess()
          document.getElementById("landing-form").reset();
        } catch (err) {
          console.log(err)
          showError(genericError);
        }

        $(".ae-btn-submit").removeAttr("disabled");
        $("#waiting-form").addClass("d-none");

      } else {

      }
    },
    error: function (err) {
      var obj = JSON.parse(JSON.stringify(err));
      //console.log("ERR");
      //console.log(obj);
      if (obj.status === 400) {
        var objResp = JSON.parse(JSON.stringify(obj.responseJSON));
        console.log(obj.responseJSON);
        if (objResp.status === 3) {
          var em = "";
          //console.log(objResp.validationErrors);
          $.each(objResp.validationErrors, function (k, er) {
            if (er["fieldName"] == "phonenumber") {
              em = em + errorMessagePhone + "<br />";
            }
            if (er["fieldName"] == "email") {
              em = em + errorMessageEmail + "<br />";
            }
          });
          if (em.length == 0) {
            em = genericError;
          }
          showError(em);
        } else
        if (objResp.status === 4) {
          //email esistente
          showError(userExistError);
        } else {
          showError(genericError);
        }
      }
      $(".ae-btn-submit").removeAttr("disabled");
      $("#waiting-form").addClass("d-none");
    }
  });

}



function getUrlParameter(sParam) {

  var sPageURL = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1)),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : sParameterName[1];
    }
  }
};

//create json from form data
function objectifyForm(formArray) {

  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
    returnArray[formArray[i]['name']] = formArray[i]['value'];
  }
  return returnArray;
}

function showError(err) {
  bootbox.alert({
    centerVertical: true,
    message: '<h5 class="text-danger text-uppercase"></h5><div class="text-danger">' + err + '</div>'
  });
}

function showSuccess() {
  bootbox.alert({
      centerVertical: true,
      message: '<div id="form-success"><h5 class="text-uppercase">' + successTitle + '</h5><div>' + successMessage + '</div></div>',
    }

  );
}

function GetProvince() {
  $("#province").attr("disabled", "disabled");
  $("#provincename").val("");
  $("#province").find('option').not(':first').remove();
  $("#city").attr("disabled", "disabled");
  $("#cityname").val("");
  $("#city").find('option').not(':first').remove();
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: provinceUrl + "?product=",
    success: function (resp) {
      //console.log(resp);
      if (resp != null) {
        var obj = JSON.parse(JSON.stringify(resp));
        //console.log(obj);
        CreateSelect($("#province"), obj);
        if (obj.length > 0) {
          $("#province").removeAttr("disabled");
        }
      }
    },
    error: function (resp) {
      //console.log(resp);

    }

  });
}

function GetComuni(provincia) {
  //console.log(provincia);
  var defaultValue = "";
  $("#city").attr("disabled", "disabled");
  $("#cityname").val("");
  $("#city").find('option').not(':first').remove();
  if (provincia !== defaultValue) {
    $.ajax({
      async: true,
      type: "GET",
      beforeSend: function (request) {
        request.setRequestHeader("X-LID", $("#lid").val());
      },
      url: comuniUrl + "?province=" + provincia,
      success: function (resp) {
        //console.log(resp);
        if (resp != null) {
          var obj = JSON.parse(JSON.stringify(resp));
          //console.log(obj);
          CreateSelect($("#city"), obj);
          if (obj.length > 0) {
            $("#city").removeAttr("disabled");
          }
        }
      },
      error: function (resp) {
        // console.log(resp);

      }

    });
  }

}

function GetPurchaseIntention() {
  $("#purchaseintention").attr("disabled", "disabled");
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: storeUrl + "?key=purchaseIntention",
    success: function (resp) {
      if (resp != null) {
        var obj = JSON.parse(JSON.stringify(resp));
        // console.log(obj);
        CreateSelectPurchaseIntention($("#purchaseintention"), obj);
        $("#purchaseintention").removeAttr("disabled");
      }
    },
    error: function (resp) {
      //console.log(resp);

    }

  });
}


function CreateSelect(select, data) {
  var html = select.html();
  $.each(data, function (key, val) {
    html += "<option value=" + encodeURIComponent(val["id"]) + ">" + val["title"] + "</option>"
  });
  select.html(html);
}

function CreateSelectPurchaseIntention(select, data) {
  var html = select.html();
  $.each(data["value"], function (key, val) {
    html += "<option value=" + encodeURIComponent(val["value"]) + ">" + val["text"] + "</option>"

  });
  select.html(html);
}


/**** GDPR ****/

function GetFormDescriptor() {
  $.ajax({
    async: true,
    type: "GET",
    beforeSend: function (request) {
      request.setRequestHeader("X-LID", $("#lid").val());
    },
    url: gdprFormDescriptor,
    success: function (resp) {
      if (resp != null) {
        $("#gdpr").val(JSON.stringify(resp));
        GenerateFields(resp);
        $(".ae-btn-submit").removeAttr("disabled");
       // setInfoSectionPosition();
      }
    },
    error: function (resp) {
      //console.log(resp)

    }

  });
}

function GenerateFields(x) {
  $.each(x, function (key, val) {
    if (key === "policies") {
      $.each(val, function (index, value) {
        if (value.type === "checkbox") {
          GenerateChecbox(value)
        }

        if (value.type === "radio") {
          GenerateRadio(value)
        }

      });
    }


  });


}

function GenerateChecbox(policy) {
  var html =
    '<div class="form-group custom-control custom-checkbox">' +
    '<input type="checkbox" class="custom-control-input gdpr-checkbox" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '" value="1" ' + (policy.required ? "required" : "") + ' />' +
    '<label class="gdpr-policy-label custom-control-label" for="gdpr_' + policy.id + '">' + policy.description + ' *</label>' +
    '</div>' +
    '</div>';

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);

}

function GenerateRadio(policy) {
  var html = ' <div class="form-group"> ' +
    '<div><div class="gdpr-scrollable">' +
    policy.title + " *<br />" + policy.description +
    '<br />' +
    '</div>' +
    '<div class="custom-control custom-radio custom-control-inline">' +
    '<input class="custom-control-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-0" value="1" required />' +
    '<label class="custom-control-label" for="gdpr_' + policy.id + '-0">' + policy.accept_label + '</label>' +
    '</div>' +
    '<div class="custom-control custom-radio custom-control-inline">' +
    '<input class="custom-control-input gdpr-radio " type="radio" name="gdpr_' + policy.id + '" id="gdpr_' + policy.id + '-1" value="0" /> ' +
    '<label class="custom-control-label" for="gdpr_' + policy.id + '-1">' + policy.deny_label + '</label>' +
    '</div>' +
    '</div></div>'

  var old = $("#gdpr-block").html();
  $("#gdpr-block").html(old + html);
}